import { render, staticRenderFns } from "./DFundsPop.vue?vue&type=template&id=4bd60e74&"
import script from "./DFundsPop.vue?vue&type=script&lang=js&"
export * from "./DFundsPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports